import { sample } from 'effector';
import { debounce } from 'patronum';
import { signout } from '@features/common';
import { $openedId } from '../../detail-sdui-opened-id';
import { updateTicketList } from '../../page';
import {
  $addRelation,
  $allreadyRelatedTickets,
  $isBackConfirmDialogOpened,
  $relatedAvailable,
  $relatedAvailableOptions,
  $successRelatedSave,
  $tableData,
  addRelatedAvailable,
  clearAllreadyRelatedTickets,
  clearRelatedAvailable,
  forceRelatedSave,
  fxGetRelatedAvailable,
  fxRelatedCheck,
  fxRelatedSave,
  getRelatedAvailable,
  resetSuccessRelatedSave,
  setIsBackConfirmDialogOpened,
  startRelatedCheck,
} from '../model';

$relatedAvailableOptions.reset([fxGetRelatedAvailable.pending, signout]);

$relatedAvailable
  .on(addRelatedAvailable, (_, data) => data)
  .reset([clearRelatedAvailable, signout]);

sample({
  clock: debounce({
    source: getRelatedAvailable,
    timeout: 500,
  }),
  target: fxGetRelatedAvailable,
});

sample({
  clock: fxGetRelatedAvailable.doneData,
  source: $relatedAvailable,
  fn: (relatedAvailable, { items }) => {
    const relatedAvailableIds = relatedAvailable?.map(({ id }) => id) ?? [];

    return [
      ...relatedAvailable,
      ...items.filter(({ id }) => !relatedAvailableIds.includes(id)),
    ];
  },
  target: $relatedAvailableOptions,
});

sample({
  clock: $addRelation,
  filter: (addRelation) => !addRelation,
  target: clearRelatedAvailable,
});

sample({
  clock: startRelatedCheck,
  source: $relatedAvailable,
  fn: (relatedAvailable) => ({ tickets: relatedAvailable.map(({ id }) => id) }),
  target: fxRelatedCheck,
});

/** Проверка не нашла уже прикрепленных заявок */
sample({
  clock: [fxRelatedCheck.doneData, forceRelatedSave],
  source: {
    relatedAvailable: $relatedAvailable,
    openedId: $openedId,
    tableData: $tableData,
  },
  filter: (_, data) => !data?.tickets.length,
  fn: ({ relatedAvailable, openedId, tableData }) => {
    const combinedRelated = [
      ...relatedAvailable.map(({ id }) => id),
      ...tableData.map(({ number }) => number.id),
    ];
    const filteredRelated = [...new Set(combinedRelated)];

    return {
      id: openedId!,
      related: filteredRelated,
    };
  },
  target: fxRelatedSave,
});

/** Проверка нашла уже прикрепленные заявки, сохраняю данные для таблицы в переменную */
sample({
  clock: fxRelatedCheck.doneData,
  filter: ({ tickets }) => !!tickets.length,
  fn: ({ tickets }) =>
    tickets.map(({ id, number, incident }) => ({
      id,
      ticketNumber: number,
      incidentNumber: incident.number,
    })),
  target: $allreadyRelatedTickets,
});
$allreadyRelatedTickets.reset([fxRelatedCheck, clearAllreadyRelatedTickets, signout]);

$successRelatedSave.reset([resetSuccessRelatedSave, signout]);

sample({
  clock: fxRelatedSave.done,
  fn: () => true,
  target: [$successRelatedSave, updateTicketList],
});

$isBackConfirmDialogOpened
  .on(setIsBackConfirmDialogOpened, (_, status) => status)
  .reset([signout]);
